import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { pageMeta } from "@/lib/pagination";

/** Prev/next pager for the paginated list endpoints. Renders nothing when a
 *  single page holds everything. `onChange` receives the new offset. */
export default function Pagination({ total = 0, limit = 100, offset = 0, onChange }) {
  const m = pageMeta({ total, limit, offset });
  if (m.total <= limit && offset === 0) return null;

  return (
    <div className="flex items-center justify-between p-4 border-t border-[#A9C0E0]/40" data-testid="pagination">
      <div className="text-xs text-[#475569]" data-testid="pagination-summary">
        Showing <span className="font-semibold text-[#0E2F76]">{m.from}–{m.to}</span> of {m.total}
      </div>
      <div className="flex items-center gap-2">
        <button
          className="vtx-btn-ghost inline-flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed"
          disabled={!m.hasPrev}
          onClick={() => onChange(Math.max(0, offset - limit))}
          data-testid="pagination-prev"
        >
          <ChevronLeft size={14} /> Prev
        </button>
        <span className="text-xs font-semibold text-[#475569]" data-testid="pagination-page">
          Page {m.page} / {m.pageCount}
        </span>
        <button
          className="vtx-btn-ghost inline-flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed"
          disabled={!m.hasNext}
          onClick={() => onChange(offset + limit)}
          data-testid="pagination-next"
        >
          Next <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
